export interface MegaMenuItem {
  url?: string;
  label: string;
  children?: MegaMenuItemChildren[];
}

interface MegaMenuItemChildren extends MegaMenuItem {
  expaned?: boolean;
}
